/* eslint-disable react/no-children-prop */
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import TimeAgo from 'react-timeago';
import { SelectShowCloudAgents } from 'store/Agents/selectors';
import { Wrapper, Label, Content, Tool } from './styled';

const LastExecution = ({ lastExecution, tool }) => {
  const intl = useIntl();
  const showCloudAgents = useSelector(SelectShowCloudAgents);
  const labelId = showCloudAgents ? 'agents.cloudAgents.lastToolExecution' : 'agents.item.lastExecution';
  const label = intl.formatMessage({ id: labelId });
  const noExecution = intl.formatMessage({ id: 'agents.item.lastExecution.never' });

  return (
    <Wrapper>
      <Label children={ label } />
      <Content>
        { lastExecution ? <TimeAgo date={ lastExecution } /> : <div children={ noExecution } /> }
        { tool && <Tool>{` (${tool})`}</Tool> }
      </Content>
    </Wrapper>
  );
};

LastExecution.propTypes = {
  lastExecution: PropTypes.string,
  tool: PropTypes.string
};

LastExecution.defaultProps = {
  lastExecution: null,
  tool: ''
};

export default LastExecution;
